import { render } from "./MDMDeploymentInstructions.vue?vue&type=template&id=38178f31&scoped=true&ts=true"
import script from "./MDMDeploymentInstructions.vue?vue&type=script&lang=ts"
export * from "./MDMDeploymentInstructions.vue?vue&type=script&lang=ts"

import "./MDMDeploymentInstructions.vue?vue&type=style&index=0&id=38178f31&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38178f31"]])

export default __exports__